module.exports = __webpack_public_path__ + "static/img/11.0888c752.png";